import React, { useState } from "react";

// Importing icons from lucide-react
import { ArrowUpDown, HelpCircle } from "lucide-react";

const PriceList = () => {
  // State to store search query (currently unused)
  const [search] = useState("");
  // Placeholder state, currently unused
  const [, ] = useState(false);

  // Sample price data
  const priceData = [
    { description: "1-7 ALIGNERS (DUAL ARCH)", category: "N/A", price: "£37.00", turnaround: "10 days" },
    { description: "3D PRINTED MODELS", category: "N/A", price: "£20.00", turnaround: "10 days" },
    { description: "3D PRINTED MODEL (FULL PALATE)", category: "N/A", price: "£12.50", turnaround: "10 days" },
    { description: "3D PRINTED STUDY MODELS", category: "STUDY MODELS", price: "£12.50", turnaround: "5 days" },
    { description: "8-14 ALIGNERS (DUAL ARCH)", category: "N/A", price: "£23.00", turnaround: "10 days" },
    { description: "ACRYLIC DENTURE WITH IMPLANT ATTACHMENT (2 LOCATORS)", category: "IMPLANTS", price: "£370.00", turnaround: "10 days" },
  ];

  // Filtering data based on the search query (currently no search functionality)
  const filteredData = priceData.filter((item) =>
    item.description.toLowerCase().includes(search.toLowerCase())
  );

  // Placeholder function for handling the edit action (print or filter buttons)
  const handleEdit = (user) => {
    
  };

  return (
    <div style={{ padding: "12px", backgroundColor: "white" }}>
      {/* Header section with Price List title and buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          padding: "5px",
          borderRadius: "5px",
        }}
      >
        <h3 style={{ color: "#004aad", margin: 0 }}>Price List</h3>
        {/* Buttons on the right: Print and Filter */}
        <div
          style={{
            display: "flex",
            gap: "12px",
          }}
        >
          <button 
            style={{
              height: "37px",
              marginRight: '10px',
              width: "60px",
              backgroundColor: "#004aad",
              borderColor: "#004aad"
            }}
            onClick={(e) => { e.stopPropagation(); handleEdit(); }} 
            className="btn btn-primary btn-sm"
          >
            Print
          </button>
          <button 
            style={{
              height: "37px",
              marginRight: '10px',
              width: "60px",
              backgroundColor: "#004aad",
              borderColor: "#004aad"
            }}
            onClick={(e) => { e.stopPropagation(); handleEdit(); }} 
            className="btn btn-primary btn-sm"
          >
            Filter
          </button>
        </div>
      </div>

      {/* Table header with categories and icons */}
      <table className="w-full">
        <thead>
          <tr style={{ backgroundColor: "#f4f4f4", borderTop: "3px solid #004aad", width: "100%" }}>
            <th className="p-3 text-left font-bold text-black" style={{ width: "40%" }}>Work Description</th>
            <th className="p-3 text-left font-bold text-black flex items-center gap-1" style={{ width: "7%" }}>
              Category <ArrowUpDown size={14} />
            </th>
            <th className="p-3 text-left font-bold text-black flex items-center gap-1" style={{ width: "7%" }}>
              Price <ArrowUpDown size={14} />
            </th>
            <th className="p-3 text-left font-bold text-black flex items-center gap-1" style={{ width: "6%" }}>
              Turn Around <HelpCircle size={14} />
            </th>
          </tr>
        </thead>
      </table>

      {/* Data rows displayed below the table header */}
      <div style={{ fontSize: "0.9rem", marginTop: "10px" }}>
        {filteredData.length > 0 ? (
          filteredData.map((item, index) => (
            <div key={index} style={{ padding: "8px 0", borderBottom: "1px solid #ddd" }}>
              {/* Displaying data for each row */}
              <span style={{ display: "inline-block", width: "40%", paddingLeft: "5px" }}>{item.description}</span>
              <span style={{ display: "inline-block", width: "20%" }}>{item.category}</span>
              <span style={{ display: "inline-block", width: "20%", fontWeight: "bold" }}>{item.price}</span>
              <span style={{ display: "inline-block", width: "20%" }}>{item.turnaround}</span>
            </div>
          ))
        ) : (
          <div className="text-center p-3 text-gray-500">No results found</div>
        )}
      </div>
    </div>
  );
};

export default PriceList;
